import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'editUser',
  props: {
    name: {},
    $store: {},
    _vm: {}
  },
  data: function data() {
    var _this = this;

    return {
      editUserForm: {
        oldmobile: "",
        code1: "",
        newmobile: "",
        code2: ""
      },
      editUserValidate: {
        oldmobile: [{
          required: true,
          //message: '原账号必填',
          validator: function validator(rule, value, callback) {
            var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/,
                emailReg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
                data = _this.editUserForm.oldmobile;

            if (!data) {
              callback(new Error(_this._vm.$t('loginArea.mobileEmailplaceholder')));
            } else if (!myreg.test(data) && !emailReg.test(data)) {
              callback(new Error(_this._vm.$t('loginArea.mobileInputMess')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        code1: [{
          required: true,
          message: this._vm.$t('base.verificationCodeplaceholder'),
          trigger: 'blur'
        }],
        newmobile: [{
          required: true,
          //message: '新账号必填',
          validator: function validator(rule, value, callback) {
            var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/,
                emailReg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
                data = _this.editUserForm.newmobile;

            if (!data) {
              callback(new Error(_this._vm.$t('loginArea.mobileEmailplaceholder')));
            } else if (!myreg.test(data) && !emailReg.test(data)) {
              callback(new Error(_this._vm.$t('loginArea.mobileInputMess')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        code2: [{
          required: true,
          message: this._vm.$t('base.newAccountCodeplaceholder'),
          trigger: 'blur'
        }]
      },
      nameDisabled: false,
      butDisabled: false,
      enterButton: this._vm.$t('loginArea.getvcode'),
      butDisabledNew: false,
      enterButtonNew: this._vm.$t('loginArea.getvcode')
    };
  },
  methods: {
    /**
     * 获取验证码
     * @param type
     */
    getCode: function getCode(type) {
      var _this2 = this;

      var vm = this;
      var time = 120;
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/,
          emailReg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
          url,
          params;

      if (type) {
        this.$refs.editUserForm.validateField('oldmobile', function (valide) {
          if (valide === '') {
            //判断帐号类型
            if (myreg.test(vm.editUserForm.oldmobile)) {
              url = 'handleGetsms';
              params = {
                mobile: vm.editUserForm.oldmobile,
                type: 3
              };
            } else if (emailReg.test(_this2.editUserForm.oldmobile)) {
              url = 'handleGetEmall';
              params = {
                email: vm.editUserForm.oldmobile,
                type: 3
              };
            }

            var callback = function callback(res) {
              if (res.result === 0) {
                _this2.$Message.success(res.errorMsg);

                vm.butDisabled = true;
                var setinter = setInterval(function () {
                  if (time > 0) {
                    time--;
                    vm.enterButton = time + vm._vm.$t('loginArea.getVodeSecondAfter');
                  } else {
                    vm.enterButton = vm._vm.$t('loginArea.getvcode');
                    vm.butDisabled = false;
                    clearInterval(setinter);
                  }
                }, 1000);
              } else {
                _this2.$Message.error(res.errorMsg);
              }
            };

            vm.$store.dispatch(url, params).then(function (res) {
              callback(res);
            });
          }
        });
      } else {
        this.$refs.editUserForm.validateField('newmobile', function (valide) {
          if (valide === '') {
            //判断帐号类型
            if (myreg.test(vm.editUserForm.newmobile)) {
              url = 'handleGetsms';
              params = {
                mobile: vm.editUserForm.newmobile,
                type: 3
              };
            } else if (emailReg.test(_this2.editUserForm.newmobile)) {
              url = 'handleGetEmall';
              params = {
                email: vm.editUserForm.newmobile,
                type: 3
              };
            }

            var callback = function callback(res) {
              if (res.result === 0) {
                _this2.$Message.success(res.errorMsg);

                vm.butDisabledNew = true;
                var setinter = setInterval(function () {
                  if (time > 0) {
                    time--;
                    vm.enterButtonNew = time + vm._vm.$t('loginArea.getVodeSecondAfter');
                  } else {
                    vm.enterButtonNew = vm._vm.$t('loginArea.getvcode');
                    vm.butDisabledNew = false;
                    clearInterval(setinter);
                  }
                }, 1000);
              } else {
                _this2.$Message.error(res.errorMsg);
              }
            };

            vm.$store.dispatch(url, params).then(function (res) {
              callback(res);
            });
          }
        });
      }
    },
    init: function init() {
      this.editUserForm.oldmobile = this.name;

      if (this.name) {
        this.nameDisabled = true;
      }
    },
    handleSubmit: function handleSubmit(callbak) {
      var _this3 = this;

      this.$refs["editUserForm"].validate(function (valid) {
        if (valid) {
          callbak();
        } else {
          _this3.$Message.error(_this3._vm.$t('loginArea.requireFieldsNotice'));
        }
      });
    }
  },
  mounted: function mounted() {
    this.init();
  }
};